import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Tabs as TabsComponent, Tab } from "../../../sharedComponents/Tabs";
import * as styles from "./Tabs.module.scss";

const Tabs = ({ activeKey, children, variant, className }) => (
	<TabsComponent
		activeKey={activeKey?.trim("").replace(/\s/g, "-").toLowerCase()}
		className={styles[`${variant}Tabs`]}
		tabsWrapperClassName={cx(styles[`${variant}TabsWrapper`], {
			[className]: className,
		})}
		tabsRightButtonClassName={styles[`${variant}TabsRButton`]}
		tabsLeftButtonClassName={styles[`${variant}TabsLButton`]}
		activeClassName={styles[`${variant}Active`]}
		tabClassName={styles[`${variant}Tab`]}
		tabIconClassName={styles[`${variant}Icon`]}
		panelClassName={styles[`${variant}Panel`]}>
		{children}
	</TabsComponent>
);

Tabs.defaultProps = {
	activeKey: undefined,
	variant: "stone",
	className: null,
};

Tabs.propTypes = {
	variant: PropTypes.oneOf([
		"icon",
		"stone",
		"pills",
		"classic",
		"tide",
		"merch",
		"merchMobile",
		"hotel",
	]),
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	/**
	 * The Tab, that will be active by default. If this value is not select, the first Tab will be activated by default.
	 */
	activeKey: PropTypes.string,
	className: PropTypes.string,
};
Tab.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	eventKey: PropTypes.string.isRequired,
	title: PropTypes.node.isRequired,
	icon: PropTypes.object,
};
Tab.defaultProps = {
	icon: null,
};

export default Tabs;
export { Tabs, Tab };
